import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { DownloadOption } from '../stores/AppConfigurationStore';
import { ExportFormat } from '../constants/ExportFormats';

export interface DownloadTileButtonProps {
    className?: string;
    active?: boolean;
    checked?: boolean;
    toggled?: boolean;
    onClick?: () => void;
    callback?: (value: ExportFormat) => void;
    disabled?: boolean;
    option?: DownloadOption;
}

export class DownloadTileButton extends BaseComponent<DownloadTileButtonProps, {}> {

    public render(): JSX.Element | null {
        if (this.props.option) {
            if (!this.props.option.visible) {
                return null;
            }
            return (
                <div className={'long-button-background' + (this.props.active ? ' active' : '')} onClick={this.onClick}>
                    <div className={this.cssClass()}>
                        <div className="long-button__icon" />
                        <div className="long-button__content">
                            {this.getLabel(this.props.option.type)}
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className={'long-button-background' + (this.props.active ? ' active' : '')} onClick={this.onClick}>
                <div className={this.cssClass()}>
                    <div className="long-button__icon" />
                    <div className="long-button__content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }

    protected onClick = (event: React.MouseEvent): void => {
        if (!this.props.disabled) {
            if (this.props.option && this.props.callback) {
                this.props.callback(this.props.option.type);
            } else if (this.props.onClick) {
                this.props.onClick();
            }
        }
    };

    protected getLabel(value: ExportFormat): string {
        switch (value) {
            case 'PDF':
                return t('Article List') + ' (PDF)';
            case 'EXCEL':
                return t('Article List') + ' (Excel)';
            default:
                break;
        }
        return value;
    }

    protected cssClass = (): string => {
        const result: Array<string> = ['long-button', 'with-tile-icon'];
        if (this.props.toggled != null) {
            result.push('with-icon');

            if (this.props.toggled != null) {
                result.push('toggle-box');
                if (this.props.toggled === true) {
                    result.push('checked');
                }
            }
        } else {
            result.push('dl-button');
        }

        if (this.props.disabled) {
            result.push('not-available');
        }

        if (this.props.className) {
            result.push(this.props.className);
        }
        if (this.props.checked != null) {
            result.push('with-check');
            if (this.props.checked === true) {
                result.push('checked');
            }
        }
        return result.join(' ');
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadTileButton.tsx